import { render, staticRenderFns } from "./XRays_Edit.vue?vue&type=template&id=b639ab26&scoped=true&"
import script from "./XRays_Edit.vue?vue&type=script&lang=js&"
export * from "./XRays_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b639ab26",
  null
  
)

export default component.exports